import React from "react";
import { cn } from "../lib/utils";

export function Section({ id, className, children, tone = "base", "data-testid": testId }) {
  const tones = {
    base: "bg-[#F9F6F0]",
    surface: "bg-white",
    sage: "bg-[#EEF1E9]",
    slate: "bg-[#1E293B] text-white",
  };
  return (
    <section id={id} data-testid={testId} className={cn("py-16 sm:py-24", tones[tone], className)}>
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8">{children}</div>
    </section>
  );
}

export function Eyebrow({ children }) {
  return (
    <span className="inline-block text-sm font-semibold uppercase tracking-[0.18em] text-[#2A9D8F]">
      {children}
    </span>
  );
}

export function StatusBadge({ status, label }) {
  const map = {
    inclus: "bg-[#2A9D8F] text-white",
    offert: "bg-[#9CAF88] text-[#1E293B]",
    supplement: "bg-[#D4B499] text-[#1E293B]",
    sur_evaluation: "bg-amber-100 text-amber-900 border border-amber-300",
    non_offert: "bg-gray-100 text-gray-500 border border-gray-300 line-through",
  };
  return (
    <span className={cn("inline-block rounded-full px-3 py-1 text-xs font-semibold", map[status] || "bg-gray-100")}>
      {label}
    </span>
  );
}
